module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tablefield-' + _vm.usedConfig.decorator, {
    tag: "component",
    class: [_vm.usedConfig.decorator],
    attrs: {
      "config": _vm.usedConfig,
      "data": _vm.usedData,
      "product": _vm.product,
      "name": "fallback"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54382350"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldFallback.vue
// module id = 682
// module chunks = 0